export default "__VITE_ASSET__zLenScI9__"